import React from 'react';

import config from 'web-config';

/* eslint-disable */
const loadSDK = (params, cb) => {
  ((d, w) => {
    var analytics = w.analytics = w.analytics || [];
    if (!analytics.initialize)
    if (analytics.invoked) console.error("Segment snippet included twice.");
    else {
      analytics.invoked = !0;
      analytics.methods = ["trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "reset", "group", "track", "ready", "alias", "debug", "page", "once", "off", "on"];
      analytics.factory = function(t) {
        return function() {
          var e = Array.prototype.slice.call(arguments);
          e.unshift(t);
          analytics.push(e);
          return analytics
        }
      };
      for (var t = 0; t < analytics.methods.length; t++) {
        var e = analytics.methods[t];
        analytics[e] = analytics.factory(e)
      }
      analytics.load = function(t, e) {
        var n = d.createElement("script");
        n.type = "text/javascript";
        n.async = !0;
        n.src = "https://cdn.segment.com/analytics.js/v1/" + t + "/analytics.min.js";
        var a = d.getElementsByTagName("script")[0];
        a.parentNode.insertBefore(n, a);
        analytics._loadOptions = e
      };
      analytics.SNIPPET_VERSION = params.version;
      analytics.load(params.id);
      analytics.page();
    }
  })(document, window);
};
/* eslint-enable */


type Props = {
  version?: string,
};

/**
 * Analytics
 * @version 1.0.0
 * @author [Ubayd Rahmonzoda](ubayd.rahmonzoda@gmail.com)
 */
class Analytics extends React.Component<Props> {
  static defaultProps = {
    version: '4.1.0',
  };

  componentDidMount() {
    const { version } = this.props;
    loadSDK(
      {
        id: config.segment.id,
        version,
      },
      () => {
        console.log('segment loaded');
      },
    );
  }

  render() {
    return null;
  }
}

export default Analytics;
